import ReportsServer from 'src/internal/errors/utils/ReportsServer';

import type {ErrorScope, Severity} from 'src/internal/errors/types';
import type {ObservabilityConfig} from 'src/types';

const reporters = new Map<string, ReportsServer>();

export function initReports(
  id: string,
  config: ObservabilityConfig,
): ReportsServer {
  let server = reporters.get(id);
  if (!server) {
    server = new ReportsServer(config);
    reporters.set(id, server);
  }

  return server;
}

export function report(
  method: Exclude<Severity, 'info'>,
  id: string,
  error: any,
  scope?: ErrorScope,
): void {
  const server = reporters.get(id);

  server?.[method](error, scope);
}
